import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { SAVE_LEVEL } from '../../../../constants/Level';

class SelectedLevel extends Component {
    render() {
        const { selected, selectedHotel } = this.props;
        const configHotelText = selected.level === SAVE_LEVEL.HOTEL && !_.isEmpty(selectedHotel) && (
            <span>
                {' '}
                | <span className="spark-bold">Hotel {selectedHotel.id}</span> {selectedHotel.name}
            </span>
        );
        const configFullText = (
            <h4>
                For <span className="spark-bold">Chain {selected.chain.Id}</span>
                {configHotelText}
            </h4>
        );

        return configFullText;
    }
}

const mapStateToProps = state => {
    return {
        selectedHotel: state.app.selected.selectedHotel,
        selected: state.app.selected
    };
};

export default connect(mapStateToProps)(SelectedLevel);



// WEBPACK FOOTER //
// ./src/components/pages/manage/common/SelectedLevel.js